/**
 * @generated SignedSource<<181e2e48254120939e710c40d9cb5447>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type HelpLayoutBackgroundType = "COLOR" | "IMAGE" | "TRANSPARENT" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type heroElementFragment$data = {
  readonly homePageTitle: string | null | undefined;
  readonly showCSMAISearchTrigger: boolean | null | undefined;
  readonly useGlobalSettings: boolean | null | undefined;
  readonly userLanguageTag: string | null | undefined;
  readonly visualConfig: {
    readonly backgroundColor: string | null | undefined;
    readonly backgroundImage: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly backgroundType: HelpLayoutBackgroundType | null | undefined;
    readonly foregroundColor: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "heroElementFragment";
};
export type heroElementFragment$key = {
  readonly " $data"?: heroElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"heroElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "heroElementFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "useGlobalSettings"
    },
    {
      "kind": "ScalarField",
      "name": "homePageTitle"
    },
    {
      "kind": "ScalarField",
      "name": "userLanguageTag"
    },
    {
      "kind": "ScalarField",
      "name": "showCSMAISearchTrigger"
    },
    {
      "concreteType": "HelpLayoutVisualConfig",
      "kind": "LinkedField",
      "name": "visualConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "foregroundColor"
        },
        {
          "kind": "ScalarField",
          "name": "backgroundColor"
        },
        {
          "kind": "ScalarField",
          "name": "backgroundType"
        },
        {
          "concreteType": "HelpLayoutBackgroundImage",
          "kind": "LinkedField",
          "name": "backgroundImage",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "url"
            }
          ]
        }
      ]
    }
  ],
  "type": "HelpLayoutHeroElement"
};

(node as any).hash = "c36bcff509304de2638e2c5648864f07";

export default node;
